import React, { useState } from 'react';
import SemanticSummary from './SemanticSummary';
import TreeView from './TreeView';
import RawDiff from './RawDiff';
import { exportDiffAsText } from '../utils/diffEngine';

const ViewMode = {
  SEMANTIC: 'semantic',
  TREE: 'tree',
  RAW: 'raw'
};

export default function DiffView({ diffResult, original, modified }) {
  const [viewMode, setViewMode] = useState(ViewMode.SEMANTIC);
  const [copySuccess, setCopySuccess] = useState(false);

  const handleCopyAll = () => {
    if (!diffResult) return;

    const text = exportDiffAsText(diffResult);
    navigator.clipboard.writeText(text).then(() => {
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    });
  };

  const handlePathClick = (path) => {
    // This could be enhanced to highlight the path in the input panes
    console.log('Path clicked:', path);
  };

  if (!diffResult && !original && !modified) {
    return (
      <div className="diff-view">
        <div className="diff-view-empty">
          <div className="empty-state">
            <span className="empty-icon">👈</span>
            <p className="empty-message">
              Enter data in both panes to see the diff
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="diff-view">
      <div className="diff-view-header">
        <div className="view-mode-tabs">
          <button
            className={`tab-btn ${viewMode === ViewMode.SEMANTIC ? 'active' : ''}`}
            onClick={() => setViewMode(ViewMode.SEMANTIC)}
          >
            📊 Semantic Summary
          </button>
          <button
            className={`tab-btn ${viewMode === ViewMode.TREE ? 'active' : ''}`}
            onClick={() => setViewMode(ViewMode.TREE)}
          >
            🌳 Tree View
          </button>
          <button
            className={`tab-btn ${viewMode === ViewMode.RAW ? 'active' : ''}`}
            onClick={() => setViewMode(ViewMode.RAW)}
          >
            📝 Raw Diff
          </button>
        </div>

        {diffResult && diffResult.hasChanges && (
          <button
            className={`copy-all-btn ${copySuccess ? 'success' : ''}`}
            onClick={handleCopyAll}
          >
            {copySuccess ? '✓ Copied!' : '📋 Copy All'}
          </button>
        )}
      </div>

      <div className="diff-view-content">
        {viewMode === ViewMode.SEMANTIC && (
          <SemanticSummary
            diffResult={diffResult}
            onPathClick={handlePathClick}
          />
        )}

        {viewMode === ViewMode.TREE && (
          <TreeView
            original={original}
            modified={modified}
            diffResult={diffResult}
            onPathClick={handlePathClick}
          />
        )}

        {viewMode === ViewMode.RAW && (
          <RawDiff
            diffResult={diffResult}
            original={original}
            modified={modified}
          />
        )}
      </div>
    </div>
  );
}
